import { p } from "./_helpers";

const industrie = {
 slug: "industrie",
 path: "/secteurs/industrie",
 hero: {
 image: "/photos/sector-industrie-hero.jpg",
 alt: p("Industrie manufacturière en Guinée-Bissau", "Manufacturing industry in Guinea-Bissau", "Indústria transformadora na Guiné-Bissau"),
 breadcrumb: p("Industrie", "Industry", "Indústria"),
 title: p("Investir dans l'industrie.", "Investing in industry.", "Investir na indústria."),
 subtitle: p(
 "Transformation locale des matières premières, unités agroalimentaires, cosmétique, packaging : la valeur ajoutée qui reste au territoire.",
 "Local processing of raw materials, agri-food units, cosmetics, packaging: the added value that stays in the territory.",
 "Transformação local das matérias-primas, unidades agroalimentares, cosmética, embalagem: o valor acrescentado que fica no território."
 ),
 },
 seo: {
 title: p(
 "Investir dans l'industrie en Guinée-Bissau | NANDA SÁ",
 "Investing in industry in Guinea-Bissau | NANDA SÁ",
 "Investir na indústria na Guiné-Bissau | NANDA SÁ"
 ),
 description: p(
 "Panorama industriel de la Guinée-Bissau : transformation locale, agroalimentaire, cosmétique, packaging, unités clé-en-main. Chiffres et opportunités.",
 "Industrial panorama of Guinea-Bissau: local processing, agri-food, cosmetics, packaging, turnkey units. Figures and opportunities.",
 "Panorama industrial da Guiné-Bissau: transformação local, agroalimentar, cosmética, embalagem, unidades chave-na-mão. Dados e oportunidades."
 ),
 keywords: "industrie Guinée-Bissau, transformation cajou, agroalimentaire Afrique de l'Ouest, packaging premium, cosmétique locale, zone industrielle CEDEAO",
 },
 presentation: {
 title: p("Transformer localement, exporter mondialement.", "Process locally, export globally.", "Transformar localmente, exportar globalmente."),
 paragraphs: p(
 [
 "Aujourd'hui, 80 à 90 % du cajou de Guinée-Bissau, une grande partie du karité, des fruits tropicaux et des produits de la mer quittent la région à l'état brut. La valeur ajoutée, décorticage, torréfaction, formulation, packaging, marque, reste captée ailleurs. C'est le principal enjeu économique du territoire : ramener la transformation à la source.",
 "Structurer une unité industrielle en Guinée-Bissau, c'est participer à cette bascule stratégique. C'est aussi bénéficier de matières premières abondantes, de coûts de production compétitifs et d'un accès direct aux marchés CEDEAO, UE (accords ACP) et diaspora.",
 ],
 [
 "Today, 80 to 90% of Guinea-Bissau's cashew, a large share of shea, tropical fruits and seafood leave the region raw. Added value, shelling, roasting, formulation, packaging, brand, is captured elsewhere. This is the main economic stake of the territory: bringing processing back to the source.",
 "Structuring an industrial unit in Guinea-Bissau or Guinée-Bissau means taking part in this strategic tipping. It also means benefiting from abundant raw materials, competitive production costs and direct access to ECOWAS, EU (ACP agreements) and diaspora markets.",
 ],
 [
 "Hoje, 80 a 90 % do caju da Guiné-Bissau, uma grande parte do karité, dos frutos tropicais e dos produtos do mar saem da região em bruto. O valor acrescentado, descasque, torrefacção, formulação, embalagem, marca, é captado noutros locais. É o principal desafio económico do território: trazer a transformação para a fonte.",
 "Estruturar uma unidade industrial na Guiné-Bissau significa participar nesta viragem estratégica. Significa também beneficiar de matérias-primas abundantes, de custos de produção competitivos e de um acesso directo aos mercados CEDEAO, UE (acordos ACP) e diáspora.",
 ]
 ),
 },
 kpis: {
 title: p("Chiffres clés de l'industrie", "Industry key figures", "Dados-chave da indústria"),
 items: [
 { n: "80-90 %", l: p("Cajou exporté brut", "Cashew exported raw", "Caju exportado em bruto"), d: p("La transformation reste à construire.", "Processing is yet to be built.", "A transformação está por construir.") },
 { n: "x 3-5", l: p("Multiple valeur ajoutée", "Value-added multiple", "Múltiplo valor acrescentado"), d: p("Amande grillée vs noix brute, écart mondial.", "Roasted kernel vs raw nut, global gap.", "Amêndoa torrada vs noz bruta, diferença mundial.") },
 { n: "ACP", l: p("Accès UE préférentiel", "Preferential EU access", "Acesso UE preferencial"), d: p("Accords partenariat économique.", "Economic partnership agreements.", "Acordos de parceria económica.") },
 { n: "CEDEAO", l: p("Marché intégré", "Integrated market", "Mercado integrado"), d: p("400 M+ habitants sans droits de douane.", "400M+ people, no customs duties.", "400 M+ habitantes, sem direitos aduaneiros.") },
 { n: "€ 2/j", l: p("Salaire industriel min.", "Min. industrial wage", "Salário industrial mín."), d: p("Compétitivité coût encore forte.", "Still strong cost competitiveness.", "Competitividade custo ainda forte.") },
 { n: "0", l: p("Zone industrielle certifiée", "Certified industrial zone", "Zona industrial certificada"), d: p("À créer, position pionnière disponible.", "To be created, pioneer position available.", "A criar, posição pioneira disponível.") },
 ],
 sources: p(
 "Sources : ANIP Guinée-Bissau, ADEPME Banque africaine de développement, données 2023-2025.",
 "Sources: ANIP Guinea-Bissau, ADEPME African Development Bank, data 2023-2025.",
 "Fontes: ANIP Guiné-Bissau, ADEPME Banco Africano de Desenvolvimento, dados 2023-2025."
 ),
 },
 opportunites: {
 title: p("Segments d'investissement prioritaires", "Priority investment segments", "Segmentos de investimento prioritários"),
 intro: p(
 "Quatre segments à forte valeur ajoutée, avec des accès marché structurés.",
 "Four high value-added segments with structured market access.",
 "Quatro segmentos de forte valor acrescentado com acesso ao mercado estruturado."
 ),
 segments: [
 { h3: p("1. Unités de transformation cajou (décorticage, torréfaction, aromatisation)", "1. Cashew processing units (shelling, roasting, flavouring)", "1. Unidades de transformação do caju (descasque, torrefacção, aromatização)"),
 p: p("Le champ historique de NANDA SÁ / NANDA SÁ. Ticket : 500 000 à 3 M€.", "NANDA SÁ / NANDA SÁ's historic field. Ticket: €500k to €3M.", "O campo histórico da NANDA SÁ / NANDA SÁ. Ticket: 500 000 a 3 M€.") },
 { h3: p("2. Unités agroalimentaires (mangue, hibiscus, moringa, huile de palme)", "2. Agri-food units (mango, hibiscus, moringa, palm oil)", "2. Unidades agroalimentares (manga, hibisco, moringa, óleo de palma)"),
 p: p("Séchage, mise en jus, pulpes, huiles vierges. Ticket : 300 000 à 1,5 M€.", "Drying, juicing, pulps, virgin oils. Ticket: €300k to €1.5M.", "Secagem, sumo, polpas, óleos virgens. Ticket: 300 000 a 1,5 M€.") },
 { h3: p("3. Cosmétique et pharmacopée (baobab, karité, plantes)", "3. Cosmetics and pharmacopoeia (baobab, shea, plants)", "3. Cosmética e farmacopeia (baobá, karité, plantas)"),
 p: p("Positionnement premium, proximité avec NANDA SÁ Cosmétiques. Ticket : 200 000 à 800 000 €.", "Premium positioning, proximity with NANDA SÁ Cosmétiques. Ticket: €200k to €800k.", "Posicionamento premium, proximidade com NANDA SÁ Cosmétiques. Ticket: 200 000 a 800 000 €.") },
 { h3: p("4. Packaging et emballage local", "4. Local packaging", "4. Embalagem local"),
 p: p("Carton, verre, sachets, filière absente, marché captif. Ticket : 400 000 à 1,5 M€.", "Cardboard, glass, pouches, absent value chain, captive market. Ticket: €400k to €1.5M.", "Cartão, vidro, saquetas, fileira ausente, mercado cativo. Ticket: 400 000 a 1,5 M€.") },
 ],
 },
 defis: {
 title: p("Les défis à anticiper", "Challenges to anticipate", "Desafios a antecipar"),
 intro: p(
 "L'industrie exige rigueur, capital patient et maîtrise énergétique.",
 "Industry demands rigour, patient capital and energy mastery.",
 "A indústria exige rigor, capital paciente e domínio energético."
 ),
 items: p(
 [
 "Sécurisation énergétique, solaire + backup diesel indispensables (voir NANDA SÁ Energia Pro).",
 "Chaîne d'approvisionnement de la matière première à contractualiser avec les coopératives.",
 "Normes qualité et sanitaires (HACCP, BRC, IFS) à intégrer dès la conception.",
 "Formation industrielle des équipes, partenariats avec NANDA SÁ Académie.",
 ],
 [
 "Energy security, solar + diesel backup indispensable (see NANDA SÁ Energia Pro).",
 "Raw material supply chain to be contracted with cooperatives.",
 "Quality and sanitary standards (HACCP, BRC, IFS) to be integrated from design.",
 "Industrial team training, partnerships with NANDA SÁ Académie.",
 ],
 [
 "Segurança energética, solar + backup diesel indispensáveis (ver NANDA SÁ Energia Pro).",
 "Cadeia de abastecimento da matéria-prima a contratualizar com as cooperativas.",
 "Normas de qualidade e sanitárias (HACCP, BRC, IFS) a integrar desde a concepção.",
 "Formação industrial das equipas, parcerias com a NANDA SÁ Académie.",
 ]
 ),
 closing: p(
 "Ces défis sont autant de barrières à l'entrée qui protègent, à terme, celles et ceux qui les ont franchies avec méthode.",
 "These challenges are so many entry barriers that ultimately protect those who cross them methodically.",
 "Estes desafios são outras tantas barreiras à entrada que a prazo protegem quem as atravessa com método."
 ),
 },
 pourquoi: {
 title: p("La Maison qui transforme.", "The House that transforms.", "A Casa que transforma."),
 paragraphs: p(
 [
 "NANDA SÁ transforme déjà le cajou et les produits de terroir. NANDA SÁ Cosmétiques formule des cosmétiques botaniques. ENERGIA PRO sécurise l'énergie industrielle. NANDA SÁ Académie forme les équipes. Ce sont ces quatre piliers, combinés, qui rendent notre pôle industriel opérationnel.",
 ],
 [
 "NANDA SÁ already processes cashew and terroir products. NANDA SÁ Cosmétiques formulates botanical cosmetics. ENERGIA PRO secures industrial energy. NANDA SÁ Académie trains teams. It is these four pillars, combined, that make our industrial hub operational.",
 ],
 [
 "A NANDA SÁ já transforma o caju e os produtos do terroir. A NANDA SÁ Cosmétiques formula cosméticos botânicos. A ENERGIA PRO garante a energia industrial. A NANDA SÁ Académie forma as equipas. São estes quatro pilares, combinados, que tornam o nosso pólo industrial operacional.",
 ]
 ),
 bullets: p(
 [
 "Étude de faisabilité industrielle",
 "Sécurisation énergétique et environnementale",
 "Contractualisation coopératives et sourcing",
 "Normes qualité, export et certifications",
 "Formation des équipes techniques",
 ],
 [
 "Industrial feasibility study",
 "Energy and environmental security",
 "Cooperative and sourcing contracting",
 "Quality, export and certification standards",
 "Technical team training",
 ],
 [
 "Estudo de viabilidade industrial",
 "Segurança energética e ambiental",
 "Contratualização com cooperativas e sourcing",
 "Normas de qualidade, exportação e certificações",
 "Formação das equipas técnicas",
 ]
 ),
 },
 download: {
 title: p("Télécharger la note « Industrie · Guinée-Bissau ».", "Download the brief « Industry · Guinea-Bissau ».", "Descarregar a nota « Indústria · Guiné-Bissau »."),
 body: p(
 "Note préparée par NANDA SÁ : chiffres clés, unités-types, cadre juridique, contacts utiles.",
 "Brief prepared by NANDA SÁ: key figures, unit templates, legal framework, useful contacts.",
 "Nota preparada pela NANDA SÁ: dados-chave, unidades-tipo, enquadramento jurídico, contactos úteis."
 ),
 pdfUrl: "/pdf/nanda-sa-note-industrie.pdf",
 pdfFilename: "nanda-sa-note-industrie.pdf",
 mailSubject: p("Téléchargement de la note « Industrie »", "Download of the brief « Industry »", "Descarga da nota « Indústria »"),
 mailBody: p(
 "Bonjour, je souhaite recevoir la note « Industrie · Guinée-Bissau ».",
 "Hello, I would like to receive the brief « Industry · Guinea-Bissau ».",
 "Olá, gostaria de receber a nota « Indústria · Guiné-Bissau »."
 ),
 },
 contact: {
 title: p("Parlons de votre projet industriel.", "Let's talk about your industrial project.", "Falemos do seu projecto industrial."),
 body: p(
 "Industriel, transformateur, sourceur, financier, coopérative : décrivez votre intention, nous répondons personnellement.",
 "Industrialist, processor, sourcer, financier, cooperative: describe your intention, we respond personally.",
 "Industrial, transformador, sourceur, financeiro, cooperativa: descreva a sua intenção, respondemos pessoalmente."
 ),
 quote: p(
 "Ce qu'un pays transforme lui-même, il finit par le vendre au monde.",
 "What a country processes itself, it eventually sells to the world.",
 "Aquilo que um país transforma por si próprio acaba por vender ao mundo."
 ),
 subject: p("Investir dans l'industrie en Guinée-Bissau", "Invest in industry in Guinea-Bissau", "Investir na indústria na Guiné-Bissau"),
 },
 ctas: ["NandaSa", "Energia", "Eleone", "Conseil"],
};

export default industrie;
